import React, { ReactNode } from 'react';
import { useNavigate } from 'react-router-dom';
import { AppliedJobsStore } from './applied-jobs.store';

const AppliedJobsContext = React.createContext<AppliedJobsStore | null>(null);

export const AppliedJobsProvider = ({ children }: { children: ReactNode }) => {
   const navigate = useNavigate();
   const [store] = React.useState<AppliedJobsStore>(() => new AppliedJobsStore(navigate));

   return <AppliedJobsContext.Provider value={store}>{children}</AppliedJobsContext.Provider>;
};

export const useAppliedJobs = () => {
   const ctx = React.useContext(AppliedJobsContext);
   if (!ctx) {
      throw new Error('useAppliedJobs must be used inside AppliedJobsProvider');
   }

   return ctx;
};

